import { render } from "./CRM_Customer_View.vue?vue&type=template&id=ce6e95b6&scoped=true"
import script from "./CRM_Customer_View.vue?vue&type=script&lang=js"
export * from "./CRM_Customer_View.vue?vue&type=script&lang=js"

import "./CRM_Customer_View.vue?vue&type=style&index=0&id=ce6e95b6&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6e95b6"]])

export default __exports__